import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { BuyerOrderContent } from "./BuyerOrderContent";
import { SupplierOrderContent } from "./SupplierOrderContent";

export const OrderContentContainer = ({
  order,
}: {
  order: OrderGetResponseType;
}) => {
  const { business } = useSellarCurrentBusiness();
  return (
    <>
      {business?.Supplier ? (
        <SupplierOrderContent order={order} />
      ) : (
        <BuyerOrderContent order={order} />
      )}
    </>
  );
};
